module.exports = __webpack_public_path__ + "33488529c2e6d9dd11954a486668966e.svg";